import { MESApiService, type spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import type { TimerSpeedPoint } from "../models/TimerSpeedReport";

interface RawTimerSpeedRow {
	ProductSizeID: number | null;
	Name: string | null;
	Timer: number | null;
	Speed: number | null;
}

export interface GetTimerSpeedReportParams {
	start: string;
	end: string;
	signal?: AbortSignal;
}

export const getTimerSpeedReport = async ({
	start,
	end,
	signal,
}: GetTimerSpeedReportParams): Promise<TimerSpeedPoint[]> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "start", value: start },
		{ name: "end", value: end },
	];

	const spName = "[MILL].[GetTimerSpeedReportDataWeb]";
	const resp = await apiService.callV2(spName, parameters, signal);

	if (!resp.ok) {
		throw new Error(resp.message || "Error fetching timer speed report");
	}

	const rows = get(resp, "data.tables[0].rows", []) as RawTimerSpeedRow[];

	// The procedure also returns CrewId, ShiftId, ProductionDate and Start. The
	// legacy chart plots none of them and neither does this one, and a long range
	// brings back ~95k rows, so they are left unmapped rather than converted per
	// row for a tooltip nobody asked for.
	const points: TimerSpeedPoint[] = [];

	for (const row of rows) {
		if (row.Timer == null) continue;
		points.push({
			ProductSizeId: row.ProductSizeID,
			ProductName: row.Name?.trim() || "—",
			Timer: Number(row.Timer),
			Speed: row.Speed == null ? null : Number(row.Speed),
		});
	}

	return points;
};
